import {
    Typography,
} from "@mui/material";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import StayAtPepiniere from "./components/StayAtPepiniere";
//import StayPayment from "./components/StayPayment";
import StayArriveOnFriday from "./components/StayArriveOnFriday";
import StayFindMyRoom from "./components/StayFindMyRoom";
import StayPepinierePlan from "./components/StayPepinierePlan";


const Stay: React.FC = () => {

    return (
        <>
            <Typography variant="h4" gutterBottom sx={{mb: 4, color: 'text.primary'}}>
                Loger
            </Typography>

            <StayAtPepiniere/>

            <StayArriveOnFriday/>
            <StayPepinierePlan/>
            <StayFindMyRoom/>
            {/*<StayPayment/>*/}
        </>
    );
};

export default Stay;
